export const config = {
  title: 'AI Email Writer',
  Writetab: "Write",
  replytab:"Reply",
  Input1:"Email For Reply",
  Input1placeholder:"Paste the email content here to generate a customised reply",
  Topic : 'Key Points of Your Email',
  Topic2 : 'Key Points of Your Email(optional)',
  Topicplaceholder:'Apply for Leave Application..',
  Keypoints : 'Select Tone',
  Keypointsplaceholder:'',
  SupportiveInput: 'Select Length',
  Input2splaceholder:"Hi Maya! Lets Catch-up and discuss the project in detail",
  //color: '#FF3A12',
 
 color:'#D01B48',
  getacceseline1: ' Unlimited Email Generation',
  getacceseline2: ' Powerful AI Tool to Create personalized Emails',
  getacceseline3: ' Smart Email Reply Generation',
  getacceseline4: ' Full Access to all Features',




  //color used across web  
  primaryColor: '#D01B48',
  tabsColor: '#D01B48',


  //images used accross web
  logo: require('./assets/vector.svg').default,
  buyP: require('./assets/Group 1437252828.svg').default,
  home: require('./assets/filled.svg').default,
  homelp: require('./assets/filled leftp.svg').default,
  privacy: require('./assets/description.svg').default,
  privacylp: require('./assets/description leftp.svg').default,
  CreateEmail: require('./assets/button.svg').default,
  CreateReply: require('./assets/button2.svg').default,
  hamburger: require('./assets/USSSA - Icons_Hamburger Menu.svg').default,
  crown: require('./assets/crown 1.svg').default,
  frame: require('./assets/vector.svg').default,
  proicon: require('./assets/pro.svg').default,
  upgradetopro: require('./assets/upgradetopro.png')  ,
  righticon: require('./assets/right.svg').default,
  Backbutton: require('./assets/arrow-left.svg').default,  
  Buybutton: require('./assets/arrow long right.svg').default,
  book: require('./assets/book.svg').default, 




  //api endpoitns accross web
 // apiEndpoint: 'http://localhost/projectA/api',

 baseURL:"https://emailwriting.ai//Backend",

//baseURL:"http://localhost/",


  "FAQtitle": "How to Use Ai Email Writer?",
  "points": [
    {
      "step": "Create Email:",
      "details": [
        "Enter your email topic, select the tone, length, and language. Click 'Generate', and your email will be ready in 2-4 seconds."
      ]
    },
    {
      "step": "Generate Reply:",
      "details": [
        "Paste the email you're replying to, add your key points, and select the tone, length, and language. Click 'Generate', and your reply will be ready in 2-4 seconds."
      ]
    },
    {
      "step": "Refine Results:",
      "details": [
        "For better results, try generating multiple versions by adjusting your inputs."
      ]
    }
  ],



  //privacy page 
  "privacyTitle": "Privacy Policy for AI Email Writer",
  "privacyEffectiveDate": "13-7-2023",
  "privacyPoints": [
    {
      "heading": "1. Information We Collect",
      "subsections": [
        {
          "heading": "1.1 Personal Information",
          "content": [
            "We may collect personal information that you provide directly to us when using the App. This includes:",
            "- Your name, email address, and other contact information when you sign up or contact us for support.",
            "- Story content and other user-generated content you provide within the App.",
            "- Communication and interaction details when you communicate with other users or us through the App."
          ]
        },
        {
          "heading": "1.2 Usage Information",
          "content": [
            "When you use the App, we may automatically collect certain information about your device and usage patterns, including:",
            "- Device information (such as model, operating system version, unique device identifiers).",
            "- Log information (such as IP address, access dates and times, and referring/exit pages).",
            "- App usage data, including the features you use, the pages you visit, and the actions you take."
          ]
        }
      ]
    },
    {
      "heading": "2. Use of Information",
      "subsections": [
        {
          "heading": "2.1 Provide and Improve the App",
          "content": [
            "We use the collected information to provide, maintain, and improve the functionality and performance of the App. This includes:",
            "- Personalizing your experience and providing you with tailored content.",
            "- Enhancing the App's security and detecting, preventing, and responding to potential fraud or security issues."
          ]
        }
      ]
    },
    {
      "heading": "3. Sharing Your Information",
      "content": [
        "- We do not share your personal information with third parties, except as required by law or with your explicit consent."
      ]
    }
  ]
};
